<template>
  <ion-item :class="meta.validated && !meta.valid ? 'error' : ''">
    <ion-label position="stacked" class="ion-text-uppercase">
      {{ t(label) }} {{ required ? '*' : '' }}
    </ion-label>
    <ion-input
        v-model="field"
        :placeholder="t(placeholder)"
        :disabled="disabled"
        :required="required"
    />
  </ion-item>
  <div class="ion-text-right">
    <span class="error-text">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script lang="ts">
import { IonLabel, IonInput, IonItem } from '@ionic/vue'
import { defineRule, useField } from 'vee-validate'
import { defineComponent, watch } from 'vue'
import { required, email } from '@vee-validate/rules'
import { useI18n } from 'vue-i18n'

defineRule('required', required)
defineRule('email', email)

export default defineComponent({
  components: {
    IonLabel,
    IonInput,
    IonItem,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'formularios.email.label',
    },
    placeholder: {
      type: String,
      default: 'formularios.email.placeholder',
    },
    required: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [ 'update:modelValue' ],
  setup(props, { emit }) {
    const { t } = useI18n()
    const { value: field, errorMessage, meta } = useField(
        'input-email',
        { required: props.required, email: true },
        {
          initialValue: props.modelValue,
          label: t(props.label)
        },
    )
    watch(field, (val) => emit('update:modelValue', val))

    return {
      t,
      field,
      errorMessage,
      meta,
    }
  },
})
</script>
